import React, { useState } from 'react';
import { Box, Grid, Stack, Typography, Tooltip, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import RefreshIcon from '@mui/icons-material/Refresh';
import MuiTreeView from '@mui/lab/TreeView';
import SvgIcon from '@mui/material/SvgIcon';
import TreeItem from './GProjectG04ContentTreeItem';

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon
      // className="close" // 이 속성을 주면 나타나지 않음???
      fontSize="inherit"
      style={{ width: 14, height: 14 }}
      {...props}
    >
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

const GProjectG04ContentTreeView = ({
  from,
  crudMode,
  itemsWithDocus,
  filteredItems,
  selected: selectedProps = [],
  onSelect: onSelectProps = () => {},
  disableMultiParentSelection = true,
  handleClickViewEachDoc,
  handleClickInfoMateialApprovalSummary,
  handleClickViewSummary,
  handleClickAddSubstituteTestDoc,
  reGenerate,
  onDocumentSelected,
}) => {
  const [expanded, setExpanded] = useState([]);
  const [loading, setLoading] = useState(false);

  const collectIds = (node) => {
    const ids = [];
    
    function traverse(item) {
      if (item.id) {
        ids.push(item.id);
      }
      if (item.children && Array.isArray(item.children)) {
        item.children.forEach(traverse);
      }
    }
    
    traverse(node);
    return ids;
  };

  const handleExpandClick = () => {
    const ids = itemsWithDocus.flatMap(collectIds);

    setExpanded((oldExpanded) =>
      oldExpanded.length === 0 ? ids : [],
    );
  };

  const handleCheckClick = () => {
    onSelectProps([]);
  }

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  return (
    <Box sx={{ 
      border: '1px solid #e0e0e0', 
      borderRadius: '4px', 
      overflow: 'hidden',
      position: 'relative',  // 추가
      height: '95%',       // 높이 설정 (필요에 따라 조정)
      overflowY: 'auto'      // 세로 스크롤 추가
    }}>
      <Box sx={{ 
        bgcolor: '#f5f5f5', 
        pl: 2,
        pr: 2,
        pb: 1,
        pt: 1,
        borderBottom: '1px solid #e0e0e0',
        position: 'sticky',  // 고정 위치 설정
        top: 0,              // 상단에 고정
        zIndex: 1,           // 다른 요소 위에 표시
      }}>
        <Grid container>
          <Grid item xs={3}>
            <Stack direction="row" display="flex" alignItems="center">
              <Tooltip title={expanded.length === 0 ? "전체 펼치기" : "전체 닫기"}>
                <IconButton
                  onClick={handleExpandClick}
                  size="small"
                >
                  {expanded.length === 0 ? <AddIcon /> : <RemoveIcon />}
                </IconButton>
              </Tooltip>
              {
                from?.source === "GProjectG04GeneratorDialog" && (
                  <Tooltip title="모든 체크 해제">
                    <IconButton
                      onClick={handleCheckClick}
                      size="small"
                    >
                      <CheckBoxOutlineBlankIcon />
                    </IconButton>
                  </Tooltip>
                )
              }
              {
                from?.source === "GProjectG04GeneratorDialog" && (
                  <Tooltip title="서류 다시 검색">
                    <IconButton
                      size="small"
                      onClick={async () => {
                        setLoading(true);
                        await reGenerate();
                        setExpanded([]);
                        setTimeout(() => setLoading(false), 1000);
                      }}
                    >
                      <RefreshIcon />
                    </IconButton>
                  </Tooltip>
                )
              }
              <Typography variant="subtitle1" sx={{ pl: 20 }}>목차</Typography>
            </Stack>
          </Grid>
          <Grid item xs={9}>
            <Stack direction={"row"} display="flex" alignItems="center">
              <Typography variant="subtitle1" sx={{ pl: 24 }}>설명</Typography>
              <Typography variant="subtitle1" sx={{ pl: 5.2 }}>보기</Typography>
              <Typography variant="subtitle1" sx={{ pl: 15 }}>만료일</Typography>
              <Typography variant="subtitle1" sx={{ pl: 14 }}>최종수정일시</Typography>
            </Stack>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ p: 2 }}>
        <MuiTreeView
          defaultCollapseIcon={<MinusSquare />}
          defaultExpandIcon={<PlusSquare />}
          expanded={expanded}
          onNodeToggle={handleToggle}
        >
          {
            itemsWithDocus?.length > 0 && (
              <TreeItem
                crudMode={crudMode}
                items={filteredItems}
                selected={selectedProps}
                onSelect={onSelectProps}
                disableMultiParentSelection={disableMultiParentSelection}
                handleClickViewEachDoc={handleClickViewEachDoc}
                handleClickInfoMateialApprovalSummary={handleClickInfoMateialApprovalSummary}
                handleClickViewSummary={handleClickViewSummary}
                handleClickAddSubstituteTestDoc={handleClickAddSubstituteTestDoc}
                reGenerate={reGenerate}
                readOnly={from?.source !== "GProjectG04GeneratorDialog"}
                onDocumentSelected={onDocumentSelected}
              />
            )
          }
        </MuiTreeView>
      </Box>
    </Box>
  );
};

export default GProjectG04ContentTreeView;
